import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue";
import {useAccountState} from "@/hooks/useAccountState";
import {UserTypes} from "@/models/User/UserTypes";

type vNavigationProps = {
  open: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vNavigation',
  props: {
    open: { type: Boolean }
  },
  emits: ["openNavigation", "closeNavigation"],
  setup(__props: any, { emit }) {

const props = __props as {
  open: boolean;
};



const accountState = useAccountState();

onMounted(() => {
  $(document).off("click.pg.sidebar.data-api", '[data-toggle-pin="sidebar"]');
  $(document).off("click.pg.sidebar.data-api", '[data-toggle="sidebar"]');
});

const isAdmin = computed(() => {
  const adminTypes = [UserTypes.Administrator, UserTypes.SuperAdministrator, UserTypes.Helpdesk];
  return adminTypes.includes(accountState.value.userDetails.userType);
});
const moveNavigation = computed(() => {
  const styles: Record<string, string> = {
    backgroundColor: isAdmin.value ? "#2b303b" : "#b71c1c",
    color: "#ffebee !important"
  };

  // Let the Pages sidebar plugin control transform during desktop hover mode.
  if (props.open) {
    styles.transform = "translate(210px, 0px)";
  }

  return styles;
});

function openNavigation() {
  emit("openNavigation");
}

function closeNavigation() {
  emit("closeNavigation");
}

function pinSidebar() {
  const body = $("body");
  const footer = $('.footer');

  if (body.hasClass("menu-pin")) {
    body.removeClass("menu-pin");
    footer.css('margin-left', 'auto');
  }

  else {
    body.addClass("menu-pin");
    footer.css('margin-left', '280px');
  }
}

return { __sfc: true,props, emit, accountState, isAdmin, moveNavigation, openNavigation, closeNavigation, pinSidebar }
}

})